customElements.get("details-disclosure") || customElements.define("details-disclosure", class extends HTMLElement {
  constructor() {
    super(), this.init();
  }
  init() {
    this.details = this.querySelector("details"), this.summary = this.querySelector("summary"), 
    this.contentContainer = this.querySelector("details + *"), this.scrollLockValue = this.getAttribute("data-scroll-lock"), 
    this.scrollLock = null !== this.scrollLockValue, this.isMenu = this.hasAttribute("data-menu"), 
    this.outsideTouch = this.hasAttribute("data-outside-interaction");
    const t = this.getAttribute("data-nudge");
    this.nudgeValue = "" === t ? "both" : t, this.desktopMQ = matchMedia("(min-width: 1024px)"), 
    this.bindEvents();
  }
  bindEvents() {
    this.onclick = this.handleClick, this.details.onfocusout = this.handleFocusOut, 
    this.details.ontoggle = this.handleToggle, this.outsideTouch && (this.boundTouchHandler = this.handleOutsideTouch, 
    this.boundClickHandler = this.handleOutsideClick), (this.nudgeValue || this.scrollLock) && this.desktopMQ.addEventListener("change", this.handleMediaChange);
  }
  shouldApplyNudge=() => {
    if (!this.nudgeValue) return !1;
    const t = this.desktopMQ.matches;
    return "desktop" === this.nudgeValue ? t : "tablet" !== this.nudgeValue || !t;
  };
  dispatchNudge=t => {
    this.shouldApplyNudge() ? requestAnimationFrame(() => {
      let e = "";
      if (t && this.contentContainer) {
        const t = this.contentContainer.getBoundingClientRect(), s = 20, i = 20, n = window.innerHeight - t.top, o = Math.ceil(n - s + i);
        o > 0 && (e = `translateY(-${o}px)`);
      }
      this._sendNudgeEvent(e);
    }) : t || this._sendNudgeEvent("");
  };
  _sendNudgeEvent(t) {
    const e = this.id ? `nudge-${this.id}` : `nudge-disclosure-${this.tagName.toLowerCase()}`;
    document.dispatchEvent(new CustomEvent("global-ui:bottom-right-nudge", {
      detail: {
        source: e,
        transform: t,
        target: "all"
      }
    }));
  }
  handleToggle=() => {
    const t = this.details.open;
    this.summary.setAttribute("aria-expanded", t.toString());
    const e = document.body.classList;
    if (t) {
      if (this.shouldApplyScrollLock() && e.add("overflow-clip"), this.isMenu && e.add("is-menu-open"), 
      this.contentContainer) {
        const t = e => {
          e && e.target !== this.contentContainer || (this.contentContainer.removeEventListener("transitionend", t), 
          this.contentContainer.removeEventListener("animationend", t), this.dispatchNudge(!0));
        };
        this.contentContainer.addEventListener("transitionend", t), this.contentContainer.addEventListener("animationend", t), 
        requestAnimationFrame(() => {
          const e = getComputedStyle(this.contentContainer);
          parseFloat(e.transitionDuration) > 0 || parseFloat(e.animationDuration) > 0 || t();
        });
      }
      this.boundTouchHandler && document.addEventListener("touchstart", this.boundTouchHandler, {
        passive: !1
      }), this.boundClickHandler && document.addEventListener("click", this.boundClickHandler);
    } else this.shouldApplyScrollLock() && e.remove("overflow-clip"), this.isMenu && e.remove("is-menu-open"), 
    this.dispatchNudge(!1), this.boundTouchHandler && document.removeEventListener("touchstart", this.boundTouchHandler), 
    this.boundClickHandler && document.removeEventListener("click", this.boundClickHandler);
  };
  shouldApplyScrollLock=() => {
    if (!this.scrollLock) return !1;
    const t = this.desktopMQ.matches;
    switch (this.scrollLockValue) {
     case "desktop":
      return t;

     case "tablet":
      return !t;

     default:
      return !0;
    }
  };
  close=() => {
    this.details.open && (this.details.open = !1, this.summary.setAttribute("aria-expanded", "false"));
  };
  handleClick=t => {
    (t.target.hasAttribute?.("data-close") || t.target.closest?.("[data-close]")) && this.close();
  };
  handleFocusOut=() => {
    requestAnimationFrame(() => {
      this.contains(document.activeElement) || this.close();
    });
  };
  handleOutsideTouch=t => {
    this.contains(t.target) || "INPUT" === t.target.tagName || (t.preventDefault(), 
    t.stopPropagation(), this.close());
  };
  handleOutsideClick=t => {
    this.contains(t.target) || "INPUT" === t.target.tagName || (t.preventDefault(), 
    t.stopPropagation(), this.close());
  };
  handleMediaChange=() => {
    if (this.details.open) {
      const t = document.body.classList;
      this.shouldApplyScrollLock() ? t.add("overflow-clip") : t.remove("overflow-clip"), 
      this.dispatchNudge(!0);
    }
  };
});